const state = {
  phpStore:
    [
      {
        id: 1,
        title_en: "PHP 8.0 Starter",
        title_ua: "PHP 8.0 Стартовий",
        title_es: "PHP 8.0 Inicio",
        regnumber: "TP45675166",
        grade: "1000 / 1000",
        examdate: "17.08.2022",
        image: "https://testprovider.com/ru/search-certificate/tp45675166",
      },
      {
        id: 2,
        title_en: "PHP 7.4 Essential",
        title_ua: "PHP 7.4 Базовий",
        title_es: "PHP 7.4 Básico",
        regnumber: "TP92998740",
        grade: "988 / 1000",
        examdate: "01.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp92998740",
      },
      {
        id: 3,
        title_en: "PHP Advanced",
        title_ua: "PHP Поглиблений",
        title_es: "PHP Avanzado",
        regnumber: "TP47801691",
        grade: "1000 / 1000",
        examdate: "28.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp47801691",
      },
      {
        id: 4,
        title_en: "Laravel",
        title_ua: "Laravel",
        title_es: "Laravel",
        regnumber: "TP85284868",
        grade: "1000 / 1000",
        examdate: "10.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp85284868",
      },
      {
        id: 5,
        title_en: "Magento 2",
        title_ua: "Magento 2",
        title_es: "Magento 2",
        regnumber: "TP17795504",
        grade: "1000 / 1000",
        examdate: "14.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp17795504",
      },
      {
        id: 6,
        title_en: "YII2 Essential",
        title_ua: "YII2 Базовий",
        title_es: "YII2 Básico",
        regnumber: "TP21584504",
        grade: "1000 / 1000",
        examdate: "22.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp21584504",
      },
      {
        id: 7,
        title_en: "YII2 Advanсed",
        title_ua: "YII2 Поглиблений",
        title_es: "YII2 Avanzado",
        regnumber: "TP21335122",
        grade: "1000 / 1000",
        examdate: "26.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp21335122",
      },
      {
        id: 8,
        title_en: "PHP Symfony Web Development",
        title_ua: "Веб розробка на PHP Symfony",
        title_es: "Desarrollo Web con PHP Symfony",
        regnumber: "TP16870523",
        grade: "1000 / 1000",
        examdate: "30.09.2022",
        image: "https://testprovider.com/ru/search-certificate/tp16870523",
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};